import React from "react";
import {MainLeftTitle } from '../../../_uiComponents/WrapperComponents'
import CreateRolesForm from "./forms/CreateRolesForm";

export const CreateRoles = () => {
    return (
        <>
            <div className='sbt-data-grid__wr'>
                <MainLeftTitle title="Create Roles">
                    </MainLeftTitle>
                <CreateRolesForm/>
            </div>
        </>
    )
}